var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWheelSettings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_533_18237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5986 11.5071L27.9465 10.0317L24.5802 11.3255L24.1222 13.2156L22.3618 21.2015L28.0781 23.6917L28.7875 22.7759C29.7662 20.7685 30.3151 18.5129 30.3151 16.1288C30.3151 14.5175 30.063 12.9649 29.5986 11.5071Z",
    fill: "#FE7D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7138 20.2326L21.7075 21.2016L16.5498 24.8346L18.8486 29.9632L20.4897 30.3699V30.3705C24.1571 29.0067 27.1081 26.2234 28.8084 22.7338L23.7138 20.2326Z",
    fill: "#EE6161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5247 24.981L17.4304 24.214L10.8906 23.2208L7.74854 28.2687L9.19482 30.0903V30.0909C11.0346 30.8822 13.0618 31.3204 15.1913 31.3204C17.0548 31.3204 18.8395 30.9852 20.4893 30.3704V30.3698L18.5247 24.981Z",
    fill: "#C2A1D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1922 23.0916L7.55723 17.3815L1.21484 19.3437V22.0915C2.74564 25.6757 5.61531 28.5518 9.19505 30.0909V30.0902L11.4935 24.8345L11.1922 23.0916Z",
    fill: "#8AC9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.68557 8.88794L0.963381 10.7964H0.962742C0.340318 12.4558 0 14.2527 0 16.1289C0 18.2457 0.433074 20.2607 1.21478 22.0915H1.21542L6.50634 19.8756L7.19811 18.2866L7.61346 10.4704L2.68557 8.88794Z",
    fill: "#75CDD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6372 2.44904H8.57719C5.08317 4.14167 2.33568 7.13289 0.962891 10.7964H0.96353L6.32098 12.8447L9.82395 11.0714L14.4565 6.9042L11.6372 2.44904Z",
    fill: "#6CF5C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1898 13.2157L23.9092 11.968L20.451 12.8447L20.2647 14.4408C20.4419 14.9711 20.5372 15.5391 20.5372 16.1289C20.5372 16.9452 20.3542 17.7179 20.0273 18.4094L20.1022 19.6829L22.3618 20.8853L23.7132 20.2326C24.312 18.9916 24.6478 17.5996 24.6478 16.1289C24.6479 15.1124 24.4867 14.1337 24.1898 13.2157Z",
    fill: "#FD6930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0276 18.4094C19.4435 19.646 18.3995 20.6221 17.1163 21.1173L16.623 22.0451L17.6512 24.6781L18.5249 24.981C20.8042 24.1225 22.6638 22.4101 23.7135 20.2326L20.0276 18.4094Z",
    fill: "#E94444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1164 21.1172C16.5196 21.3482 15.8703 21.4748 15.1916 21.4748C14.4649 21.4748 13.7728 21.3303 13.1414 21.0667L12.0625 21.1836L10.7793 23.7997L11.4935 24.8345C12.6296 25.3181 13.8796 25.5855 15.1916 25.5855C16.3648 25.5855 17.4881 25.3719 18.525 24.981L17.1164 21.1172Z",
    fill: "#A274BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2991 18.2866L9.45502 17.6763L6.70043 18.6308L6.50635 19.8756C7.46781 22.1024 9.26024 23.8852 11.4934 24.8345L13.1413 21.0667C11.874 20.5409 10.8524 19.5398 10.2991 18.2866Z",
    fill: "#26A6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4745 2.79447C20.3124 1.61104 17.8303 0.937439 15.1916 0.937439C12.8202 0.937439 10.5762 1.48054 8.57715 2.44904L11.0406 7.63057L13.488 8.72816L21.1887 10.0319L23.4293 5.27701L22.4745 2.79447Z",
    fill: "#FEE97D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9772 10.3333C32.0533 10.5527 31.9318 10.7913 31.7105 10.8604L29.6378 11.5071L25.712 12.7321C24.8344 10.0044 22.9294 7.73801 20.4512 6.38953L22.4457 2.79444L23.5012 0.891986C23.6125 0.690481 23.8684 0.619475 24.0674 0.73526C27.7367 2.86225 30.575 6.26351 31.9772 10.3333Z",
    fill: "#FEC165"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84555 16.1289C9.84555 15.4911 9.95685 14.8796 10.1622 14.3128L10.115 12.0844H7.82264L6.32082 12.8447C5.94212 13.8676 5.73486 14.9742 5.73486 16.1289C5.73486 17.4601 6.00993 18.7267 6.50634 19.8756L10.2991 18.2866C10.0074 17.6271 9.84555 16.8972 9.84555 16.1289Z",
    fill: "#2ABCC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9595 8.25061L11.0405 7.63049C8.86999 8.69111 7.16648 10.5597 6.3208 12.8447L10.1622 14.3128C10.6304 13.0167 11.5849 11.9536 12.806 11.3439V11.3433L13.686 10.3525L12.9595 8.25061Z",
    fill: "#00F2A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6924 7.80968L19.6916 7.80955C18.3534 7.0842 16.8208 6.6723 15.1915 6.6723C13.7023 6.6723 12.2937 7.01646 11.0405 7.63057L12.8061 11.344C13.5238 10.9858 14.3343 10.783 15.1915 10.783C16.0973 10.783 16.95 11.0082 17.6972 11.406L19.0426 11.4723L20.359 9.71706L19.6924 7.80968Z",
    fill: "#FEDF30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7118 12.7321L24.1612 13.2157L20.2647 14.4407C19.829 13.13 18.8774 12.0334 17.6748 11.3943L19.6635 7.80965L20.451 6.38953C22.9291 7.738 24.8341 10.0044 25.7118 12.7321Z",
    fill: "#FDB441"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_533_18237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelSettings);
export default __webpack_public_path__ + "static/media/wheel-settings.95ee6c51b8be39bc9908f16cf1e87915.svg";
export { ForwardRef as ReactComponent };